import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-actions-bar-component flex gap align-items-center flex-responsive" }
const _hoisted_2 = { class: "left flex-auto" }
const _hoisted_3 = { class: "center flex gap-small flex-1 align-items-center" }
const _hoisted_4 = { class: "right flex gap-small flex-auto align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeftComponent = _resolveComponent("ArrowLeftComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.returnLink !== undefined)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.returnLink,
            class: "flex gap-small align-items-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowLeftComponent),
              _createElementVNode("span", null, _toDisplayString(_ctx.returnText), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "center")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ]))
}